import { render } from "./ProfessionDetailPage.vue?vue&type=template&id=1b74bac6&scoped=true"
import script from "./ProfessionDetailPage.vue?vue&type=script&lang=js"
export * from "./ProfessionDetailPage.vue?vue&type=script&lang=js"

import "./ProfessionDetailPage.vue?vue&type=style&index=0&id=1b74bac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b74bac6"]])

export default __exports__